import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoMetricAggregatesReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_metric_aggregates" />
);

export default KlaviyoMetricAggregatesReport;
